import React from "react";
import { Link } from "react-router-dom";
import { useLang } from "../../i18n/LanguageContext";
import { ArrowRight, Sparkles } from "lucide-react";
import Hummingbird from "../brand/Hummingbird";

const StartHereTeaser = () => {
  const { t } = useLang();
  return (
    <section className="relative py-32 lg:py-40 bg-[#081328]" data-testid="starthere-teaser">
      <div className="container-sat max-w-[1100px]">
        <div className="relative rounded-[28px] border border-white/8 bg-[#0E1A30] overflow-hidden p-8 md:p-16">
          <div className="absolute -right-6 -bottom-6 opacity-30 pointer-events-none">
            <Hummingbird size={220} color="#D4AF37" />
          </div>

          <div className="relative max-w-2xl">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-white/5 border border-white/10 text-[#D4AF37] text-xs tracking-widest uppercase">
              <Sparkles size={14} /> {t("starthere.overline")}
            </div>
            <h2 className="headline-xl text-4xl md:text-6xl mt-6">{t("starthere.title")}</h2>
            <p className="text-white/70 text-lg mt-5 leading-relaxed">{t("starthere.subtitle")}</p>
            <div className="mt-8 flex flex-col sm:flex-row gap-4">
              <Link to="/quiz" className="btn-primary" data-testid="starthere-quiz-cta">{t("starthere.cta")} <ArrowRight size={18} /></Link>
              <Link to="/lebensrad" className="btn-secondary" data-testid="starthere-wheel-cta">{t("starthere.cta_secondary")}</Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default StartHereTeaser;
